export const ENV = (process.env.REACT_APP_ENV || 'production').trim();

/** Persist auth + conta em localStorage só quando `REACT_APP_ENV=development` (refresh não perde sessão no dev). */
export const IS_DEV_SESSION_PERSIST = window.location.hostname.includes('localhost');

export const DEV_PERSIST_STORAGE_KEYS = {
  authToken: 'orbita-dev-authToken',
  refreshToken: 'orbita-dev-refreshToken',
  accountsSsid: 'orbita-dev-accountsSsid',
  selectedAccountEmail: 'orbita-dev-selected-account-email'
} as const;

export const IS_PROD = ENV === 'production';
export const BRANCH_NAME = (process.env.REACT_APP_BRANCH_NAME || '').trim();

export const ACCOUNTS_ENV = process.env.REACT_APP_ACCOUNTS_ENV || 'homolog';
export const ACCOUNTS_TOKEN = process.env.REACT_APP_ACCOUNTS_TOKEN || '';
export const ACCOUNTS_CONNECT_TOKEN = process.env.REACT_APP_ACCOUNTS_CONNECT_TOKEN || '';

export const VERTICAL_URL = (process.env.REACT_APP_VERTICAL_URL || '').trim();
export const HIGH_TICKET_PRODUCTS_URL = (process.env.REACT_APP_HIGH_TICKET_PRODUCTS_URL || VERTICAL_URL).trim();
export const EDUZZ_ACCOUNT_URL = (process.env.REACT_APP_EDUZZ_ACCOUNT_URL || '').trim();
export const ELITE_BADGES_URL = (process.env.REACT_APP_ELITE_BADGES_URL || 'https://cdn.eduzzcdn.com/badges').trim();
export const ANTICIPATION_HELP_URL = (
  process.env.REACT_APP_ANTICIPATION_HELP_URL ||
  'https://ajuda.eduzz.com/hc/pt-br/articles/4402057357211-Como-funciona-a-antecipa%C3%A7%C3%A3o-%C3%93rbita-'
).trim();

export const API_FIDIC = (process.env.REACT_APP_API_FIDIC || '').trim();
export const API_MYEDUZZ = (process.env.REACT_APP_API_MYEDUZZ || '').trim();
export const URL_ORBITA = (process.env.REACT_APP_URL_ORBITA || '').trim();
export const SALES_PAGE_URL = (process.env.REACT_APP_SALES_PAGE_URL || '').trim();

export const URL_SELECT = `${VERTICAL_URL}/showcase`;
export const URL_DOCS_FISCAIS = `${VERTICAL_URL}/docs-fiscais`;
export const ELITE_DASHBOARD_URL = `${VERTICAL_URL}/dashboard-elite`;
export const IMPACT_ANALYTICS_URL = `${VERTICAL_URL}/analytics`;
export const HOST_ORBITA = (process.env.REACT_APP_HOST_ORBITA || '').trim();

export const BUILD_NUMBER = (process.env.REACT_APP_BUILD_NUMBER || '').trim();
export const BUILD_DATE = (process.env.REACT_APP_BUILD_DATE || '').trim();
export const BUILD_NAME = (process.env.REACT_APP_BRANCH_NAME || '').trim();

if (!API_MYEDUZZ) throw new Error('Please provide an API_MYEDUZZ');

export const SENTRY_DSN = (process.env.REACT_APP_SENTRY_DSN || '').trim();

export const TOAST_DEFAULT_TIMEOUT = 3000;
export const TOAST_ERROR_TIMEOUT = 15000;

export const IS_DEVELOPMENT = ENV === 'development';
export const GOOGLE_ANALYTICS = (process.env.REACT_APP_GOOGLE_ANALYTICS || '').trim();
export const CLARITY_ID = (process.env.REACT_APP_CLARITY_ID || '').trim();
export const NOTIFICATION_SOCKET_URL = (process.env.REACT_APP_NOTIFICATION_SOCKET_URL || '').trim();

export const INTERCOM_API = 'https://api-iam.intercom.io';
export const INTERCOM_APP_ID = 'kbctel9j';

export const MELHOR_ENVIO_AUTH_URL = (process.env.REACT_APP_MELHOR_ENVIO_AUTHORIZATION_URL || '').trim();
export const CHECKOUT_SUN_URL = process.env.REACT_APP_CHECKOUT_SUN_URL;
export const CHECKOUT_ELEMENTS_URL = process.env.REACT_APP_CHECKOUT_ELEMENTS_URL;

export const SPREADSHEET_API_URL = process.env.REACT_APP_SPREADSHEET_API_URL;

export const WEBCHAT_PROXY_URL = process.env.REACT_APP_WEBCHAT_PROXY_URL;
export const WEBCHAT_CLIENT_ID = process.env.REACT_APP_WEBCHAT_CLIENT_ID;

export const CONSOLE_URL = process.env.REACT_APP_CONSOLE_URL;

export const NPS_ACCESS_KEY = process.env.REACT_APP_NPS_ACCESS_KEY;
export const NPS_JOURNEY = 'nps_soft_launch_-_base_reduzida';

export const BLINKET_URL = process.env.REACT_APP_BLINKET_URL;
export const STORE_URL = process.env.REACT_APP_STORE_URL;
export const DEPOIMENTUS_URL = process.env.REACT_APP_DEPOIMENTUS_URL;
export const ALPACLASS_URL = process.env.REACT_APP_ALPACLASS_URL;
export const ALPACLASS_CONTENT_URL = process.env.REACT_APP_ALPACLASS_CONTENT_URL;
export const NEWPRODUCT_URL = process.env.REACT_APP_NEWPRODUCT_URL;
